import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import {
	ANALYTICS_SOURCE,
	BulkSpacePermissionsPage,
} from '@confluence/bulk-permissions/entry-points/BulkPermissions.tsx';
import { BulkAccessManagementPage } from '@confluence/bulk-permissions/entry-points/BulkAccess.tsx';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode.ts';

export const BulkSpacePermissionsRoute = () => {
	const { isRbacEnabled } = useSpaceRoleMode();

	return isRbacEnabled ? <BulkAccessManagementPage /> : <BulkSpacePermissionsPage />;
};

BulkSpacePermissionsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
